const c={cdnUrl:"https://static.ladies-cdn.de/lds-webcomponents"};export{c};
